import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* eslint-disable no-magic-numbers */

/* eslint-disable react/jsx-pascal-case */
import { Themed, useThemeUI } from 'theme-ui';
import { Fragment } from 'react';
import { Link, Col, Row } from '@uswitch/ev-core/react';
import Pagination from '../../elements/pagination';
import { useDataSelector, useComponentMeta } from '@uswitch/ev-utils/context/selectors';
import loadable from '@loadable/component';
import { cardVariantsMap, NO_PAGINATE_VARIANTS, CAROUSEL_VARIANTS } from '@uswitch/ev-utils/helpers/category-guides-variants';
import { path } from '@uswitch/ev-utils/obj';
import CategoryGuideCard from '../../compounds/category-guide-card';
import { useCategoryGuides } from './use-category-guides';
import { categoryGuidesStylePath } from './index';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var Carousel = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "carousel";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "carousel" */
    '../carousel');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../carousel");
    }

    return eval('require.resolve')("../carousel");
  }
});

var DefaultCategoryGuides = function DefaultCategoryGuides(_ref) {
  var variant = _ref.variant,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$guides = _ref.guides,
      guides = _ref$guides === void 0 ? [] : _ref$guides,
      layout = _ref.layout,
      title = _ref.title,
      numberOfGuides = _ref.numberOfGuides,
      _ref$sys = _ref.sys,
      sys = _ref$sys === void 0 ? {} : _ref$sys,
      showDate = _ref.showDate,
      showViewAll = _ref.showViewAll,
      _ref$showPagination = _ref.showPagination,
      showPagination = _ref$showPagination === void 0 ? true : _ref$showPagination;

  var _useDataSelector = useDataSelector(['url']),
      href = _useDataSelector.href;

  var _URL = new URL(href),
      pathname = _URL.pathname,
      searchParams = _URL.searchParams;

  var filteredGuides = useCategoryGuides({
    guides: guides,
    pathname: pathname
  });
  var total = sys.total;
  var limit = useDataSelector(['meta', 'paginationLimit'], 12);

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var guideCardMeta = useComponentMeta('guideCard');
  var cardVariant = cardVariantsMap[variant] || guideCardMeta.variant;
  var itemsPerRow = path(['compounds', 'card', 'variants', cardVariant, 'itemsPerRow'], theme) || path(['compounds', 'card', 'itemsPerRow'], theme);

  var _ref2 = (guideCardMeta === null || guideCardMeta === void 0 ? void 0 : guideCardMeta.carouselColumns) || [2, 2, 2],
      _ref3 = _slicedToArray(_ref2, 3),
      colsMobile = _ref3[0],
      colsTablet = _ref3[1],
      colsDesktop = _ref3[2];

  var isDefault = layout ? layout === 'default' : !NO_PAGINATE_VARIANTS.includes(variant);
  var isCarousel = CAROUSEL_VARIANTS.includes(variant) || layout === 'carousel';
  var queryPage = searchParams.get('page') || '';
  var showingAllGuides = queryPage === '-1';
  var paginationLimit = Math.min(numberOfGuides, limit) || limit;
  return _jsxs(Fragment, {
    children: [title ? _jsx(Themed.h3, {
      sx: {
        variant: categoryGuidesStylePath('title'),
        color: 'dark-2'
      },
      className: className,
      children: title
    }) : null, isCarousel ? _jsx(Carousel, {
      sys: sys,
      colsDesktop: colsDesktop,
      colsMobile: colsMobile,
      colsTablet: colsTablet,
      categoryGuides: filteredGuides,
      variant: cardVariant,
      showDate: showDate,
      showSimpleCard: showingAllGuides,
      children: filteredGuides.map(function (url, key) {
        return _jsx(CategoryGuideCard, {
          guide: url,
          variant: cardVariant,
          showDate: showDate,
          showSimpleCard: showingAllGuides
        });
      }, this)
    }) : _jsx(Row, {
      cols: itemsPerRow,
      wrap: true,
      children: filteredGuides.map(function (url, key) {
        return _jsx(Col, {
          span: 1,
          sx: {
            variant: categoryGuidesStylePath('column')
          },
          children: _jsx(CategoryGuideCard, {
            guide: url,
            variant: cardVariant,
            showDate: showDate,
            showSimpleCard: showingAllGuides
          })
        }, key);
      }, this)
    }), total && isDefault && !showingAllGuides ? _jsxs("div", {
      sx: {
        display: 'flex',
        justifyContent: 'center',
        my: 'sm'
      },
      children: [showPagination ? _jsx(Pagination, {
        total: total,
        limit: paginationLimit
      }) : null, showViewAll && total > paginationLimit ? _jsx(Link, {
        href: "".concat(pathname, "?page=-1"),
        sx: {
          margin: 'auto 0',
          color: 'grey-80'
        },
        children: "View All"
      }) : null]
    }) : null]
  });
};

export default DefaultCategoryGuides;
//# sourceMappingURL=default.js.map